<div class="splash" #splash fxLayout="row" fxLayoutAlign="space-around stretch">
	<div fxLayout="column" fxLayoutAlign="center center">
		<mat-spinner></mat-spinner>
	</div>
</div>
